const BASE_URL = process.env.REACT_APP_API_URL; // Ensure this is set in `.env`

// ✅ Function to trigger sitemap regeneration
export async function regenerateSitemap() {
    try {
        console.log("🚀 Regenerating sitemap...");
        const response = await fetch(`${BASE_URL}/api/sitemap/generate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" }
        });

        if (!response.ok) {
            throw new Error(`Failed to regenerate sitemap: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("✅ Sitemap successfully regenerated!", data.message);
        return { success: true, message: data.message };
    } catch (error) {
        console.error("❌ Error regenerating sitemap:", error);
        return { success: false, message: error.message };
    }
}
